import { Component, OnInit, AfterViewInit, HostListener, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Call } from '../../../models/call';

import { PhonecallService } from '../../../services/users/phonecall.service';
import { NotyService } from '../../../services/common/noty.service';

@Component({
  selector: 'app-phonecalls-index',
  templateUrl: './phonecalls-index.component.html',
  styleUrls: ['./phonecalls-index.component.scss'],
})
export class PhonecallsIndexComponent implements OnInit, OnChanges {
  @Input() extension: number;
  @Input() minimalMode: boolean = false;

  phonecalls: Array<Call> = [];
  count: number = 0;
  searching: boolean = false;
  searchOptions: any = { per_page: 20 };
  searchParams: any = { page: 1, order_by: 'start_time', order_direction: 'desc' };
  sidebarMaximized: boolean = false;
  sidebarOpen: boolean = false;
  expandedCallId: number | null = null;

  constructor(private phonecallService: PhonecallService, private notyService: NotyService) {}

  ngOnInit() {
    this.phonecallService.searchOptions().then((response_json) => {
      this.searchOptions = response_json;
      if (this.extension) this.searchParams.extension = this.extension;
      this.search();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.extension && changes.extension.currentValue) {
      this.searchParams.page = 1;
      this.searchParams.extension = this.extension;
      this.search();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 500);
    setTimeout(() => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    }, 5000);
  }

  pageChanged($event: any) {
    this.searchParams.page = $event.page;
    this.search();
  }

  search() {
    this.searching = true;
    this.phonecallService
      .index(this.searchParams)
      .then((response_json) => {
        this.searching = false;
        this.phonecalls = response_json.phonecalls;
        this.count = response_json.count;
      })
      .catch((err) => {
        console.error(err);
        this.searching = false;
        this.notyService.notify('Error getting call search results', 'error', 5000, 'topRight');
      });
  }

  clearSearch() {
    this.searchParams = { page: 1, order_by: 'start_time', order_direction: 'desc' };
    if (this.extension) this.searchParams.extension = this.extension;
    this.search();
  }

  sortBy(column: string) {
    if (this.searchParams.order_by === column) {
      this.searchParams.order_direction = this.searchParams.order_direction === 'asc' ? 'desc' : 'asc';
    } else {
      this.searchParams.order_by = column;
      this.searchParams.order_direction = 'desc';
    }
    this.searchParams.page = 1;
    this.search();
  }

  sortIcon(column: string): string {
    if (this.searchParams.order_by !== column) return 'fa-sort';
    return this.searchParams.order_direction === 'asc' ? 'fa-sort-up' : 'fa-sort-down';
  }

  toggleDetail(callId: number) {
    this.expandedCallId = this.expandedCallId === callId ? null : callId;
  }

  // Positioning events and methods
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: any) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: any) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 20;
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 20;
      }

      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 95;
    }
  }
}
